import { useModalContentToggler } from '@components'

import { useCallback } from 'react'

import type { UiSourceValue } from '@features/reconciliation/enums'

import { ConnectBankContent } from '../../../bankAccounts/elements/ConnectBankContent'
import { BankView } from '../../../bankAccounts/elements/ConnectBankContent/enums/bankView'
import { SubjectReconciliationModalStateId } from '../../enums/SubjectReconciliationModalStateId'

interface ReconciliationConnectBankBodyProps {
  uiSource: UiSourceValue
}

export const ReconciliationConnectBankBody = ({ uiSource }: ReconciliationConnectBankBodyProps) => {
  const { setActiveState } = useModalContentToggler()

  const handleImportCsvClick = useCallback(() => {
    setActiveState(SubjectReconciliationModalStateId.ImportCsv)
  }, [setActiveState])

  return (
    <ConnectBankContent bankView={BankView.ConnectModal} uiSource={uiSource} onImportCsvClick={handleImportCsvClick} />
  )
}
